import React from 'react';
import './App.css';
import CustomerSegmentFeatures from './customer_segment_features';
import { Routes, Route } from "react-router-dom";
import {Home} from './home';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='customer-segment-features' element={<CustomerSegmentFeatures/>}/>
      </Routes>
    </div>
  );
}

export default App;
